import React from 'react'
import ManageItemsBanner from './manage-items-banner';

const ManageBanner: React.FC = () => {
    return <ManageItemsBanner title="Banner" />;
};

export default ManageBanner
